import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
import { DentalService } from 'src/app/_service/dental.service';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-list-pincode-scanpro-master',
  templateUrl: './list-pincode-scanpro-master.component.html',
  styleUrls: ['./list-pincode-scanpro-master.component.css']
})
export class ListPincodeScanproMasterComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; scanProList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles = []; circles_copy = []; circle = '';
  zones = []; zone = ''; circle_zone: boolean = true; allscanproUser: any; allscanproUser_copy: any;
  scanpro = ''; pincodes: any; pincode = ''; search_pincode = ''; pincodes_copy = [];
  constructor(public dentalapi: DentalService, private sharedapi: SharedService, public miscapi: MiscService, public leadapi: LeadsService) { }

  ngOnInit(): void {
    this.getcircle();
    this.getScanProUser();
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getCircleZone(circle_id) {
    this.zone = '';
    let qString = 'circle=' + circle_id;
    await this.miscapi.getCircle_zone(qString).subscribe((data: any) => {
      if (data.status) {
        this.zones = data.data;
        this.circle_zone = false;
      } else {
        this.zones = [];
        this.circle_zone = false;
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getScanProUser() {
    await this.dentalapi.getscanprouser().subscribe((data: any) => {
      if (data.status) {
        this.allscanproUser = data.data;
        this.allscanproUser_copy = this.allscanproUser;
      } else {
        this.allscanproUser = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'scanpro') {
      this.allscanproUser = this.sharedapi.searchData(searchtText, this.allscanproUser_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'scanpro') {
      $("#scanproSearch").val('');
      $("#scanproSearch").focus();
      this.allscanproUser = this.allscanproUser_copy;
    }
  }

  ngAfterViewInit() {
    this.loadScanProList(0, this.perpage);
  }

  async loadScanProList(pageIndex, perpage) {
    this.scanProList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'circle=' + this.circle + '&zone=' + this.zone + '&scanpro=' + this.scanpro;
    this.loading = true; this.loaded = false;
    await this.miscapi.getZoneScanProList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.scanProList = data.data;
      } else {
        this.scanProList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadScanProList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadScanProList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.circle = ''; this.zone = ''; this.scanpro = '';
    this.zones = [];
    this.loadScanProList(0, 25);
  }
  //=====Export List=====//
  exportZoneScanProList() {
    if (this.scanProList.length > 0) {
      let data = [];
      let titles = ['Circle Name', 'Zone Name', 'Scan Pro User'];

      data.push(titles);

      for (let key in this.scanProList) {
        let extData = [this.scanProList[key].circle_name, this.scanProList[key].zoneName, this.scanProList[key].scanpro_user];
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'zoneScanProlist' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Zone Scan Pro Data found!');
    }
  }


}
